import { useState } from "react";
import "./styles/errorModal.css";
import DetailErrorRoleModal from "./detailErrorRoleModal";

interface ModalProps {
  isOpen: boolean;
}

const ErrorRoleModal = ({ isOpen }: ModalProps) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!isOpen) return null;
  const showDetailsPage = ()=>{
    setShowDetails(false);
  }

  return (
    <div className="modal-overlay">
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{position: "relative", background: "linear-gradient(to bottom, rgb(96, 64, 239), rgb(128, 86, 242))", color: "white", fontFamily: "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji"}}>
      {/* <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{position: "relative", background: "linear-gradient(#5e67fb 0%, #5e67fb 5%, #383d95 100%)", color: "white", fontFamily: "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji"}}> */}
        {/* Header Section */}
        <div className="modal-header">
          <h3 style={{color: "white", fontSize: "24px"}}>PEN VIP Required</h3>
        </div>
        
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {/* Follow on X Section */}
          <div className="box-message">
            <div className="follow-x-section">
              <span>Only PEN VIP holders can use this faucet. Hold PEN on Pentagon Chain and verify your role in Discord to qualify.</span>
            </div>
            <button className="details-button" onClick={() => setShowDetails(!showDetails)}>
              {showDetails ? "Check Details" : "Check Details"}
            </button>
          </div>
          <DetailErrorRoleModal isOpen={showDetails} onClose={showDetailsPage} />
          <div className="box-message tooltip-container-new">
            <div></div>
            <div className="tooltip-new"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorRoleModal;

